import { IcoClose, IcoScale, IcoShield } from "../ui/icons";

export function LegalFrame({ onClose }: { onClose: () => void }) {
  return (
    <div className="sg-legalpg" role="dialog" aria-modal="true" aria-labelledby="sg-legal-title">
      <button type="button" className="sg-legalpg__back" aria-label="Fermer" onClick={onClose} />
      <article className="sg-legalpg__sheet">
        <header className="sg-legalpg__head">
          <div>
            <p className="sg-legalpg__kicker">
              <IcoScale />
              Aurélia Signature
            </p>
            <h2 id="sg-legal-title">Cadre de la signature</h2>
            <p className="sg-legalpg__lead">
              Signature électronique au sens de l’article 1367 du Code civil et du règlement européen eIDAS. Voici ce
              que vous pouvez en faire — et ce qui sort du logiciel.
            </p>
          </div>
          <button type="button" className="sg-btn ghost" onClick={onClose}>
            <IcoClose />
            Fermer
          </button>
        </header>

        <div className="sg-legalpg__grid">
          <section className="sg-legalpg__card is-ok">
            <h3>Vous pouvez</h3>
            <ul>
              <li>Contrats de travail (CDI, CDD, temps partiel), avenants, promesses d’embauche.</li>
              <li>Contrats de prestation, freelance, sous-traitance, partenariats.</li>
              <li>Devis, bons de commande, NDA, cessions de droits, conventions de stage.</li>
              <li>Chartes internes, règlement intérieur, délégations, feuilles d’heures.</li>
              <li>Accords clients : acceptation, livraison, intervention, attestation, PV de recette.</li>
            </ul>
          </section>
          <section className="sg-legalpg__card is-stop">
            <h3>Surtout pas</h3>
            <ul>
              <li>Actes authentiques : vente immobilière, donation, contrat de mariage, testament notarié.</li>
              <li>Tout acte pour lequel un texte impose une forme solennelle ou un notaire.</li>
              <li>Rupture conventionnelle et téléservices officiels (TéléRC, DREETS).</li>
              <li>Dépôts qui exigent une signature qualifiée ou un certificat d’un prestataire de confiance.</li>
              <li>Présenter le nom déclaré comme une identité vérifiée par pièce ou certificat.</li>
            </ul>
          </section>
        </div>
        <p className="sg-legalpg__bridge">
          L’écrit électronique a la même force que l’écrit papier lorsque le signataire est identifié et que l’intégrité
          est garantie (art. 1366 et 1367). eIDAS interdit d’écarter une signature au seul motif qu’elle est
          électronique. Les actes solennels et le circuit certificat restent hors de ce logiciel.
        </p>

        <section className="sg-legalpg__proof">
          <IcoShield />
          <div>
            <h3>Comment on le tient</h3>
            <p>
              Empreinte SHA-256 dès l’import — l’envoi est refusé si le document ne correspond plus. Journal horodaté :
              import, cases, parties, envoi, lectures, signature. Chaque acte est lié au précédent (chaîne HMAC-SHA256).
              Le signataire accepte les conditions du portail, puis la mention de consentement, avant de signer.
              Mention acceptée, heure serveur, adresse IP. La preuve reste consultable à tout moment.
            </p>
          </div>
        </section>

        <dl className="sg-legalpg__refs">
          <div>
            <dt>Art. 1366 du Code civil</dt>
            <dd>L’écrit électronique a la même force que l’écrit papier si l’auteur est dûment identifié et si l’intégrité est garantie.</dd>
          </div>
          <div>
            <dt>Art. 1367 du Code civil</dt>
            <dd>La signature identifie et manifeste le consentement. En électronique : un procédé fiable qui lie la personne à l’acte.</dd>
          </div>
          <div>
            <dt>Code du travail</dt>
            <dd>Le contrat de travail relève du droit commun (art. L. 1221-1). Le contrat de prestation est un contrat d’entreprise (art. 1710 du Code civil). Dans les deux cas, l’écrit électronique suffit si le signataire est identifié et si l’intégrité est garantie.</dd>
          </div>
          <div>
            <dt>Règlement eIDAS (n° 910/2014)</dt>
            <dd>Une signature électronique ne peut être écartée au seul motif de sa forme. Le certificat qualifié est un autre niveau, réservé aux actes qui l’exigent.</dd>
          </div>
        </dl>

        <p className="sg-legalpg__note">
          Cette page cadre l’usage du logiciel. Elle ne remplace pas l’avis d’un avocat sur un dossier précis.
        </p>
      </article>
    </div>
  );
}
